import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              {siteInfo.description}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-400 hover:text-background-50 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/popular" className="text-sm text-background-400 hover:text-background-50 transition-colors whitespace-nowrap">热门推荐</Link>
              <Link to="/category/free" className="text-sm text-background-400 hover:text-background-50 transition-colors whitespace-nowrap">免费韩漫</Link>
              <Link to="/category/premium" className="text-sm text-background-400 hover:text-background-50 transition-colors whitespace-nowrap">精品韩漫</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-background-50 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              热门平台
            </h4>
            <div className="flex flex-col gap-2">
              <a href="https://www.hanmanwang.com" rel="nofollow noopener noreferrer" target="_blank" className="text-sm text-background-400 hover:text-background-50 transition-colors whitespace-nowrap">韩漫网</a>
              <a href="https://www.hanmanzhijia.com" rel="nofollow noopener noreferrer" target="_blank" className="text-sm text-background-400 hover:text-background-50 transition-colors whitespace-nowrap">韩漫之家</a>
              <a href="https://www.hanmanwu.com" rel="nofollow noopener noreferrer" target="_blank" className="text-sm text-background-400 hover:text-background-50 transition-colors whitespace-nowrap">韩漫屋</a>
              <a href="https://www.hanmanba.com" rel="nofollow noopener noreferrer" target="_blank" className="text-sm text-background-400 hover:text-background-50 transition-colors whitespace-nowrap">韩漫吧</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <div className="flex flex-col gap-2 text-sm text-background-400">
              <span>邮箱：{siteInfo.email}</span>
              <Link to="/about" className="text-primary-300 hover:text-primary-200 transition-colors whitespace-nowrap">
                了解更多 →
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} - {siteInfo.tagline} | 版权所有
          </p>
          <p className="text-sm text-background-500">
            本站为导航聚合平台，不存储任何漫画内容
          </p>
        </div>
      </div>
    </footer>
  );
}